module.exports = __webpack_public_path__ + "img/shoot_00028.de73feb0.png";